import React, { useEffect, useState, useRef } from 'react';
import Modal from '@lingxi-common-component/sirius-ui/SiriusModal';
import Button from '@lingxi-common-component/sirius-ui/Button';
import { Spin } from 'antd';
import SiriusTable from '@lingxi-common-component/sirius-ui/Table';
import style from './sendProgress.module.scss';
import { apiHolder, apis } from 'api';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { guardString } from '@web-edm/utils';
import { Popover } from 'antd';
import ConfirmIconDelete from '@/images/icons/edm/confirm-delete16.svg';
import { FailIcon, SuccessIcon } from './sendProgress+';
const tableColumns = [
    {
        title: '收件人',
        width: '240px',
        dataIndex: 'receiver',
        render(value) {
            let result = window.apiResposity.mailApiImpl.contactHandler.handleEmailListStringToParsedContent(value, { origin: [], parsed: [] });
            let result0 = result.parsed.length > 0 ? result.parsed[0] : null;
            return React.createElement("div", { className: style.ellipsis }, result0.email || result0.name);
        },
    },
    {
        title: '发送情况',
        width: '136px',
        dataIndex: 'status',
        render(state) {
            if (state === 'success') {
                return (React.createElement("div", { className: style.success },
                    React.createElement(SuccessIcon, null),
                    React.createElement("div", { className: style.title }, "\u5DF2\u53D1\u9001")));
            }
            else if (state === 'pending') {
                return React.createElement("div", { className: style.ellipsis }, "\u53D1\u9001\u4E2D...");
            }
            else if (state === 'fail') {
                return (React.createElement("div", { className: style.fail },
                    React.createElement(FailIcon, null),
                    React.createElement("div", { className: style.title }, "\u53D1\u9001\u5931\u8D25")));
            }
            return React.createElement("div", { className: style.ellipsis }, "\u53D1\u9001\u4E2D...");
        },
    },
];
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
export const SendProgress = (props) => {
    const { composeId = '', visible, onBackToHomePage, onBackToSenderFolder } = props;
    const [loading, setLoading] = useState(false);
    const [sendInfo, setSendInfo] = useState();
    const [firstPopoverVisible, setFirstPopoverVisible] = useState(false);
    const [secondPopoverVisible, setSecondPopoverVisible] = useState(false);
    const timer = useRef(null);
    const resetTimer = () => {
        clearTimer();
        timer.current = setTimeout(() => {
            fetchData();
        }, 10000);
    };
    const clearTimer = () => {
        timer.current && clearTimeout(Number(timer.current));
        timer.current = -1;
    };
    useEffect(() => {
        visible && fetchData();
    }, [visible]);
    const fetchData = async () => {
        if (!guardString(composeId)) {
            return;
        }
        setLoading(true);
        try {
            let resp = await mailApi.checkSendState(composeId);
            handleData(resp);
        }
        catch (e) {
            let errMessage = (e && e.message) || '';
            SiriusMessage.error({ content: errMessage });
            clearTimer();
        }
        finally {
            setLoading(false);
        }
    };
    const handleData = (data) => {
        setSendInfo(data);
        let current = data.current || 0;
        let total = data.total || 0;
        if (current < total) {
            resetTimer();
        }
        else {
            clearTimer();
        }
    };
    const PopoverContentComp = () => {
        return (React.createElement("div", { className: style.alert },
            React.createElement("div", { className: style.header },
                React.createElement("img", { src: ConfirmIconDelete, style: { flexShrink: 0, marginTop: '4px' } }),
                "\u9000\u51FA\u6B64\u5F39\u6846\u540E\u5269\u4F59\u90AE\u4EF6\u4F1A\u7EE7\u7EED\u53D1\u9001\uFF0C\u4F46\u4F1A\u5173\u95ED\u5199\u4FE1\u9875\u4E14\u65E0\u6CD5\u7EE7\u7EED\u67E5\u770B\u53D1\u9001\u8FDB\u5EA6\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F"),
            React.createElement("div", { className: style.action },
                React.createElement(Button, { btnType: "minorLine", onClick: () => {
                        setFirstPopoverVisible(false);
                        setSecondPopoverVisible(false);
                    } }, "\u53D6\u6D88"),
                React.createElement(Button, { btnType: "primary", onClick: () => {
                        if (firstPopoverVisible) {
                            onBackToHomePage && onBackToHomePage();
                        }
                        if (secondPopoverVisible) {
                            onBackToSenderFolder && onBackToSenderFolder();
                        }
                        setFirstPopoverVisible(false);
                        setSecondPopoverVisible(false);
                    } }, "\u7EE7\u7EED\u8FD4\u56DE"))));
    };
    const BackToHomeButton = (doAction) => {
        return (React.createElement(Button, { btnType: "minorLine", size: "large", onClick: () => {
                doAction && onBackToHomePage && onBackToHomePage();
            } }, "\u8FD4\u56DE\u90AE\u7BB1\u9996\u9875"));
    };
    const BackToSendedButton = (doAction) => {
        let current = (sendInfo === null || sendInfo === void 0 ? void 0 : sendInfo.current) || 0;
        let total = (sendInfo === null || sendInfo === void 0 ? void 0 : sendInfo.total) || 0;
        if (total > 0 && current === total) {
            return (React.createElement(Button, { btnType: "primary", size: "large", onClick: () => {
                    doAction && onBackToSenderFolder && onBackToSenderFolder();
                } }, "\u67E5\u770B\u5DF2\u53D1\u9001\u6587\u4EF6\u5939"));
        }
        return undefined;
    };
    const FooterComp = () => {
        let current = (sendInfo === null || sendInfo === void 0 ? void 0 : sendInfo.current) || 0;
        let total = (sendInfo === null || sendInfo === void 0 ? void 0 : sendInfo.total) || 0;
        let isComplete = total > 0 && current === total;
        return (React.createElement("div", { className: style.footer },
            isComplete && BackToHomeButton(true),
            isComplete && BackToSendedButton(true),
            !isComplete && (React.createElement(Popover, { overlayClassName: style.popover, placement: "topRight", content: PopoverContentComp, trigger: "click", visible: firstPopoverVisible, onVisibleChange: setFirstPopoverVisible }, BackToHomeButton(false))),
            !isComplete && (React.createElement(Popover, { overlayClassName: style.popover, placement: "topRight", content: PopoverContentComp, trigger: "click", visible: secondPopoverVisible, onVisibleChange: setSecondPopoverVisible }, BackToSendedButton(false)))));
    };
    const loadingComp = () => {
        if (!loading) {
            return undefined;
        }
        return React.createElement(Spin, { indicator: React.createElement(LoadingIcon, null) });
    };
    const HeaderComp = () => {
        const comp = () => {
            if (loading) {
                return (React.createElement("div", { className: style.actionLoading },
                    "\u5237\u65B0...",
                    loadingComp()));
            }
            return '刷新';
        };
        return (React.createElement("div", { className: style.header },
            React.createElement("div", { className: style.title },
                "\u53D1\u9001\u8FDB\u5EA6\uFF1A",
                (sendInfo === null || sendInfo === void 0 ? void 0 : sendInfo.current) || 0,
                "/",
                (sendInfo === null || sendInfo === void 0 ? void 0 : sendInfo.total) || 0),
            React.createElement("div", { className: style.action, onClick: () => {
                    fetchData();
                } }, comp())));
    };
    useEffect(() => { }, []);
    return (React.createElement(Modal, { title: HeaderComp(), closeIcon: React.createElement("div", null), width: 480, visible: visible, footer: FooterComp() },
        React.createElement(SiriusTable, { bordered: true, columns: tableColumns, dataSource: sendInfo === null || sendInfo === void 0 ? void 0 : sendInfo.details, pagination: false })));
};
export const LoadingIcon = () => (React.createElement("div", { className: "sirius-spin", style: { width: 16, height: 16 } },
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
        React.createElement("path", { opacity: "0.27", d: "M13.9256 7.99985C13.9256 4.72706 11.2725 2.07393 7.99966 2.07393C4.72686 2.07393 2.07373 4.72706 2.07373 7.99986C2.07373 11.2727 4.72686 13.9258 7.99966 13.9258C11.2725 13.9258 13.9256 11.2727 13.9256 7.99985Z", stroke: "#4C6AFF", "stroke-width": "2" }),
        React.createElement("path", { d: "M2.07422 8.00049C2.07422 4.72769 4.72735 2.07456 8.00014 2.07456C9.99533 2.07456 11.7602 3.06058 12.8341 4.57192", stroke: "#4C6AFF", "stroke-width": "2", "stroke-linecap": "round" }))));
